import { render, staticRenderFns } from "./dlgAddGoods.vue?vue&type=template&id=3c775445&scoped=true"
import script from "./dlgAddGoods.vue?vue&type=script&lang=js"
export * from "./dlgAddGoods.vue?vue&type=script&lang=js"
import style0 from "./dlgAddGoods.vue?vue&type=style&index=0&id=3c775445&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c775445",
  null
  
)

export default component.exports